import React, { useEffect, useCallback, useState} from 'react';
import Edge from "./Edge.js";
import Speakers from "components/pulled/Speakers.js";
import AllEdges from './AllEdges.js';
import PadEffectControl from './PadEffectControl.js';
import PulledEffect from "components/pulled/PulledEffect.js"
import {connect} from 'react-redux';

const PadEffects = ({
    pad,
    effects,
    isCollapsed,
    ... props
}) => { 
    const onDelete = useCallback((fx) => {
        pad.effectRack.deleteEffect(fx);
        pad.updateEffectRedux();
    }, []);

    if (!pad.effectRack || !effects || effects.length===0) {
        return [];
    }
    if (isCollapsed) {
        return [<PadEffectControl
                  key={0}
                  pad={pad}
                  {...props}/>
               ];
    }

    return [
        <PadEffectControl
          key={0}
          pad={pad}
          {...props}
        />,
        <Speakers
          key={5}
          pad={pad}
          {...props}
        />,
        , ...
            pad.effectRack.effects.map(
                effect => 
                    <PulledEffect
                      onDelete={onDelete}
                      key={effect.id}
                      rack={pad.effectRack}
                      fx={effect}
                      showDelete={true}
                      sequencerEngine={pad.sequencerEngine}
                      pad={pad}
                      {...props}
                    />)
        ];
};

const mapStateToProps = (state, props) => {
  return {
      effects: state.pads.padEffects[props.pad.id],
      isCollapsed: state.effects.effectCollapsed[props.pad.effectRack.id]
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PadEffects);
